module.exports = __webpack_public_path__ + "static/media/iot-application-06.eea383ab.jpg";